import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  createAdmin,
  deleteAdmin,
  getAdmin,
  getAdmins,
  updateAdmin,
} from '../../lib/admins';

export const fetchAdmins = createAsyncThunk('admins/fetchAdmins', async () => {
  const data = await getAdmins();

  return data;
});

export const fetchAdmin = createAsyncThunk(
  'admins/fetchAdmin',
  async (adminId) => {
    const data = await getAdmin(adminId);

    return data;
  }
);

export const addAdmin = createAsyncThunk(
  'admins/addAdmin',
  async (body, { rejectWithValue }) => {
    try {
      const response = await createAdmin(body);

      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const editAdmin = createAsyncThunk(
  'admins/editAdmin',
  async ({ adminId, body }, { rejectWithValue }) => {
    try {
      const response = await updateAdmin(adminId, body);

      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const removeAdmin = createAsyncThunk(
  'admins/removeAdmin',
  async (adminId) => {
    const response = await deleteAdmin(adminId);

    return adminId;
  }
);
